import { Emph } from "@/components/site/Emph";

export const HeroSection = ({ c }) => {
  const meta = (c.meta || "").split("·").map((m) => m.trim()).filter(Boolean);
  return (
    <section id="top" aria-labelledby="hero-title" data-track-section="hero" data-nexus-s="0" data-nexus-dim="1" className="section hero">
      <div className="wrap">
        <div className="hero-inner reveal">
          <p className="eyebrow" data-hero-drift data-testid="hero-eyebrow">{c.eyebrow} <span>{c.eyebrow_index}</span></p>
          <h1 id="hero-title" className="hero-title" data-hero-drift data-testid="hero-title">
            {c.title_line1}<br /><span>{c.title_line2}</span>
          </h1>
          <div className="mission-lockup">
            <p className="mission-lead" data-hero-fade data-testid="hero-mission-lead"><Emph text={c.mission_lead} /></p>
            <p className="mission-support" data-hero-fade data-testid="hero-mission-support"><Emph text={c.mission_support} /></p>
          </div>
          <p className="hero-meta" data-hero-drift data-testid="hero-meta">
            {meta.map((m, i) => (
              <span key={m} className="contents">{i > 0 && <i aria-hidden="true" />}<span>{m}</span></span>
            ))}
          </p>
          <a href="#products" className="scrollhint" data-hero-drift data-testid="hero-scroll-hint">{c.scroll_hint}</a>
        </div>
      </div>
    </section>
  );
};
